import './alteracao-beneficiario/alteracao-beneficiario-controller';
import './alteracao-data-admissao-controller';
import './alteracao-matricula-controller';
import './alterar-data-validade-controller';
import './alterar-localizacao-controller';
import './alterar-senha';
import './alterar-subestipulante-controller';
import './alterar-vinculo-controller';
import './assign-aviso-de-privacidade-modal-controller';
import './assign-term-controller';
import './assign-term-uso-modal-controller';
import './aviso-de-privacidade-controller';
import './anexo-tiss';
import './beneficiario-dossie-controller';
import './beneficiary-change-controller';
import './cartao';
import './change-requests';
import './consulta-alteracao-cadastral-controller';
import './consulta-alteracao-matricula-controller';
import './consulta-alteracao-subestipulante-controller';
import './consulta-data-admissao-controller';
import './consulta-historico-inclusao-beneficiario';
import './consulta-historico-alt-cadastral-controller';
import './consulta-historico-alt-localizacao';
import './consulta-transf-titularidade-controller';
import './historico-atendimento/consulta-historico-solic-atendimento-controller';
import './consulta-inconsistencia-sib-controller';
import './consultar-alteracoes-vinculo-controller';
import './consultar-compartilhamento-risco-controller';
import './consultar-migracao-contrato-controller';
import './contrato-dossie/contrato-dossie-info-controller';
import './contrato-dossie/contrato-dossie-controller';
import './dashboard';
import './dossie-contrato-documentos-controller';
import './exclusao-beneficiario';
import './faturas';
import './folhas-pagamento';
import './historico-autorizacao';
import './historico-requisicao';
import './historico-solicitacoes-controller';
import './inclusao-beneficiario';
import './inconsistencia-beneficiario';
import './indice-reajuste/indice-reajuste-controller';
import './locator';
import './login-controller';
import './lote';
import './mensagem';
import './mensagem-toast-controller';
import './mensalidades';
import './meus-dados';
import './migracao-contrato-controller';
import './user';
import './person-data-non-editable-controller';
import './person-data-tabs-controller';
import './personal-data/personal-data-controller';
import './pesquisa-utilizacao-controller';
import './product-change-controller';
import './redirect-controller';
import './reinclusao-beneficiario';
import './repasse';
import './reset-password/reset-password-controller';
import './root-controller';
import './solicitacao-alteracao';
import './solicitacoes-pendentes';
import './stipulator/stipulator-controller';
import './tabela-preco/tabela-preco-controller';
import './transferir-titularidade-controller';
import './reports-modal-controller';
import './relatorios-controller';
import './privacidade/privacidade-controller';
import './pdf-viewer-controller';
